import Image from './image'

export default class Offer {
  constructor(object) {
    this.id = parseInt(object.id, 10) || null
    this.token = object.token || null
    this.sequentialId = parseInt(object.sequential_id, 10) || null
    this.scoutTitle = object.scout_title || null
    this.status = object.status
    this.isAvailable = object.is_available || false
    this.introducerSelectable = object.introducer_selectable || false
    this.position = object.position || null
    this.cover = object.cover ? new Image(object.cover) : null
    // DEPRECATED
    // Imageを利用する
    this.coverUrl = object.cover && object.cover.url ? object.cover.url : null
  }
}
